
            var startQuantity = $("#Quantity").val();
             var activemode=$(".get-a-quote").attr("id");
            
             $(".get-a-quote").click(function(){ 
               $("#Realoption").addClass("open"); }); 
             $(".close").click(function(){ 
               
               $("#Realoption").removeClass("open");
               $("#Quantity").val(startQuantity);
               $(".reelcutprice").val(0);
               
               
               $( ".cutm" ).each(function() { 
                $(this).val('');


                 
               });
                $( ".qtym" ).each(function() { 
                  $(this).val('');
               });
               $( ".total" ).each(function() { $(this).val(0); 
               });  
               $(".finaltotal").val(''); 
               
             }); 
             var q1=0,q2=0,q3=0,q4=0,q5=0; var c1=0,c2=0,c3=0,c4=0,c5=0; 
             $(".qtym").bind("keyup change", function(e) { var finalv=0;var qtyvalfinal=0;  
             var qtyval=$(this).val(); var cut=$(this).attr("id"); 
                //                                          if(qtyval>=10){ 
               $(this).css("border-color","#eee"); 
               $(this).attr("title",""); 
               $(".modal-body").attr("title",""); 
               var cutval= $(this).parent().find("."+cut).val();
              var camt=cutval*20;
               //alert(camt);
               var qtyvalfinal=(cutval*qtyval); qtyvalfinal=qtyvalfinal; 
               
               var qtyc=$(this).attr("name"); 
               if(qtyc=="cut1"){ 
                 var c1= $(this).val();  
                 var q1= $(this).parent().find("#qtym").val(); 
                 $("#C1F1").val(q1+" * "+c1);
                 var cutm1=$(".cutm1").val();    
                 validation(qtyc,q1);
                 if(activemode=="active"){
                 cutreelprice();
                 }
               } 
               if(qtyc=="cut2"){ 
                 var c2= $(this).val();
                 var q2= $(this).parent().find("#qtym").val(); 
                 $("#C2F2").val(q2+" * "+c2);
                 var cutm2=$(".cutm2").val();
                 validation(qtyc,q2);
                   if(activemode=="active"){
                 cutreelprice();
                 }
               }  
               if(qtyc=="cut3"){ 
                 var c3= $(this).val(); 
                 var q3= $(this).parent().find("#qtym").val(); 
                 $("#C3F3").val(q3+" * "+c3);
                 var cutm3=$(".cutm3").val(); 
                 validation(qtyc,q3);
                    if(activemode=="active"){
                 cutreelprice();
                 }
               } 
               if(qtyc=="cut4"){ 
                 var c4= $(this).val(); 
                 var q4= $(this).parent().find("#qtym").val(); 
                 $("#C4F4").val(q4+" * "+c4);
                 var cutm4=$(".cutm4").val();
                 validation(qtyc,q4);
                    if(activemode=="active"){
                 cutreelprice();
                 }
                    
               } 
               if(qtyc=="cut5"){ 
                 var c5= $(this).val(); 
                 var q5= $(this).parent().find("#qtym").val(); 
                 $("#C5F5").val(q5+" * "+c5);
                 var cutm5=$(".cutm5").val();
                 validation(qtyc,q5);
                   if(activemode=="active"){
                 cutreelprice();
                 }
                   
               } 
               var total= $(this).parent().find(".total").val(qtyvalfinal); 
               $( ".total" ).each(function() {  finalv = finalv+parseInt($(this).val());});  
               $(".finaltotal").val(finalv); 
               $(".quantity__input").val(finalv);
              // $( ".noajax" ).css('display','none');
              // $( ".addajax" ).css('display','block');
               
           /*  } 
               else{ $(this).css("border-color","red"); 
                    $(this).parent().parent().parent().parent().attr("title","error"); 
                    $(this).attr("title","error");
                    $( ".noajax" ).css('display','block');
                    $( ".addajax" ).css('display','none');
                   
                   } */
                                                         
                                                         }); 
             $(".cutm").bind("keyup change", function(e) { 
               var finalv=0; var qtyval=$(this).val(); 
               
               var cut=$(this).attr("id");  
               var cutval= $(this).parent().find("."+cut).val(); 
               var camt=qtyval*20;
               //alert(camt);
               var qtyvalfinal=(cutval*qtyval); qtyvalfinal=qtyvalfinal; 
               var total= $(this).parent().find(".total").val(qtyvalfinal);  
               var cutm=$(this).attr("name"); 
               if(cutm=="qty1"){ 
                 var q1= $(this).val();
                 var c1= $(this).parent().find("#cutm").val(); 
                 $("#C1F1").val(q1+" * "+c1);
                 var qtym1=$(".qtym1").val();    
                     validation(cutm,q1);
                       if(activemode=="active"){
                 cutreelprice();
                 }
        			                 
                    } 
                 if(cutm=="qty2"){ 
               var q2= $(this).val(); 
               var c2= $(this).parent().find("#cutm").val(); 
               $("#C2F2").val(q2+" * "+c2); 
                   var qtym2=$(".qtym2").val();    
                     validation(cutm,q2);
                      if(activemode=="active"){
                 cutreelprice();
                 }
                 
                 }  
               if(cutm=="qty3"){ 
                 var q3= $(this).val(); 
                 var c3= $(this).parent().find("#cutm").val(); 
                 $("#C3F3").val(q3+" * "+c3);
                 var qtym3=$(".qtym3").val();    
                 validation(cutm,q3);
                    if(activemode=="active"){
                 cutreelprice();
                 }
                 
               }
               if(cutm=="qty4"){ 
                   var q4= $(this).val();
                   var c4= $(this).parent().find("#cutm").val(); 
                   $("#C4F4").val(q4+" * "+c4);
                 var qtym4=$(".qtym4").val();    
                   validation(cutm,q4);
                      if(activemode=="active"){
                 cutreelprice();
                 }
               } 
               if(cutm=="qty5"){ 
                     var q5= $(this).val(); 
                     var c5= $(this).parent().find("#cutm").val(); 
                     $("#C5F5").val(q5+" * "+c5); 
                     var qtym5=$(".qtym5").val();    
                     validation(cutm,q5);
                       if(activemode=="active"){
                 cutreelprice();
                 }
               }  
               $( ".total" ).each(function() { 
                 finalv = finalv+parseInt($(this).val());}); 
               $(".finaltotal").val(finalv); 
              $(".quantity__input").val(finalv);
               //alert(finalv);
              //  $( ".noajax" ).css('display','block');
              // $( ".addajax" ).css('display','none');
               
            
               
             }); 
             $("#AddToCart").click(function() { 
               var c1f1= $("#C1F1").val(); 
               var c2f2= $("#C2F2").val(); 
               var c3f3= $("#C3F3").val(); 
               var c4f4= $("#C4F4").val();  
               var c5f5=  $("#C5F5").val(); 
               //if(c1f1=="0"){ $( "#C1F1").remove(); } 
               //if(c2f2=="0"){ $( "#C2F2").remove(); } 
               //if(c3f3=="0"){ $( "#C3F3").remove(); } 
               //if(c4f4=="0"){ $( "#C4F4").remove(); } 
               //if(c5f5=="0"){ $( "#C5F5").remove(); } 
             
              //$( ".product-form" ).submit(); 
             }); 
             $("#addtocart").click(function() { 
              
       
               var c1f1= $("#C1F1").val(); 
               var c2f2= $("#C2F2").val(); 
               var c3f3= $("#C3F3").val(); 
               var c4f4= $("#C4F4").val(); 
               var c5f5=  $("#C5F5").val();  
              //if(c1f1=="0"){$( "#C1F1").remove(); } 
              //if(c2f2=="0"){$( "#C2F2").remove();  } 
              //if(c3f3=="0"){$( "#C3F3").remove();  } 
              //if(c4f4=="0"){ $( "#C4F4").remove();  }  
              //if(c5f5=="0"){ $( "#C5F5").remove();  } 
               $( ".qtym" ).each(function(key, val) { 
                 var t1= $(this).attr("title");
                 if(t1=="error"  ){ 
                   alert("FEET MINIMUM VALUE 10"); 
                   $(".modal-body").attr("title","error");
                   return false; } }); 
                $( ".cutm" ).each(function(key, val) { 
                 var t1= $(this).attr("title");
                 if(t1=="error"  ){ 
                   alert("CUT MINIMUM VALUE ENTER"); 
                   $(".modal-body").attr("title","error");
                   return false; } }); 
               var t2= $(".modal-body").attr("title");  
               if(t2=="error"){ 
                 alert("FEET MINIMUM VALUE 10");
               //  alert('test1');
                 // $( ".noajax" ).css('display','block');
                 //$( ".addajax" ).css('display','none');
               } 
               else{ 
                // alert('test');
                // $( ".noajax" ).css('display','none');
                // $( ".addajax" ).css('display','block');
                   $("#Realoption").removeClass("open");
               $( ".product-form" ).submit(); 
              
                   
                   } 
             $("#Realoption").removeClass("open");
             }); 
             function validation(cutm,q){
                // alert(cutm);
                var cutm1=$(".cutm1").val();
                var cutm2=$(".cutm2").val();
                var cutm3=$(".cutm3").val();
                var cutm4=$(".cutm4").val();
                var cutm5=$(".cutm5").val();
               var qtym1=$(".qtym1").val();
               var qtym2=$(".qtym2").val();
               var qtym3=$(".qtym3").val();
               var qtym4=$(".qtym4").val();
               var qtym5=$(".qtym5").val();
               
            
                 var q= q;
               
                   
             if(cutm1==''){
                    $(".cutm1").css("border-color","red"); 
                    $(".cutm1").attr("title","error");
                  
                  if(qtym1==''){
                     $(".qtym1").css("border-color","#eee"); 
                     $(".qtym1").attr("title","");
                     $(".cutm1").css("border-color","#eee"); 
                     $(".cutm1").attr("title","");
                  }
               else{
                     $(".qtym1").css("border-color","#eee"); 
                     $(".qtym1").attr("title","");
                   }
                  
                }
               else{
                  $(".cutm1").css("border-color","#eee"); 
                  $(".cutm1").attr("title","");
               }
                
               
                if(cutm2==''){
                    $(".cutm2").css("border-color","red"); 
                    $(".cutm2").attr("title","error");
                  if(qtym2==''){
                     $(".qtym2").css("border-color","#eee"); 
                     $(".qtym2").attr("title","");
                     $(".cutm2").css("border-color","#eee"); 
                     $(".qtym2").attr("title","");
                  }
                   else{
                     $(".qtym2").css("border-color","#eee"); 
                     $(".qtym2").attr("title","");
                   }
                  
                }
               else{
                    $(".cutm2").css("border-color","#eee"); 
                    $(".cutm2").attr("title","");
               
               }
                   
                if(cutm3==''){
                    $(".cutm3").css("border-color","red"); 
                    $(".cutm3").attr("title","error");
                  if(qtym3==''){
                     $(".qtym3").css("border-color","#eee"); 
                     $(".qtym3").attr("title","");
                    $(".cutm3").css("border-color","#eee"); 
                     $(".cutm3").attr("title","");
                  }
                   else{
                      $(".qtym3").css("border-color","#eee"); 
                     $(".qtym3").attr("title","");
                   }
                  
                }
               else{
                   $(".cutm3").css("border-color","#eee"); 
                    $(".cutm3").attr("title","");
               
               }
                if(cutm4==''){
                    $(".cutm4").css("border-color","red"); 
                    $(".cutm4").attr("title","error");
                  if(qtym4==''){
                     $(".qtym4").css("border-color","#eee"); 
                     $(".qtym4").attr("title","");
                     $(".cutm4").css("border-color","#eee"); 
                     $(".cutm4").attr("title","");
                                        

                  }
                   else{
                      $(".qtym4").css("border-color","#eee"); 
                     $(".qtym4").attr("title","");
               
                   }
                  
                }
               else{
                    $(".cutm4").css("border-color","#eee"); 
                    $(".cutm4").attr("title","");
               }
               
                if(cutm5==''){
                    $(".cutm5").css("border-color","red"); 
                    $(".cutm5").attr("title","error");
                  if(qtym5==''){
                     $(".qtym5").css("border-color","#eee"); 
                     $(".qtym5").attr("title","");
                    $(".cutm5").css("border-color","#eee"); 
                    $(".cutm5").attr("title","");
                  }
                   else{
                      $(".qtym5").css("border-color","#eee"); 
                     $(".qtym5").attr("title","");
                   }
                  
                } 
               else{
                  $(".cutm5").css("border-color","#eee"); 
                    $(".cutm5").attr("title","");
               }
               
               /* qtym check*/
                if(qtym1==''){
                     $(".qtym1").css("border-color","red"); 
                     $(".qtym1").attr("title","error");
                  if(cutm1==''){
                    $(".cutm1").css("border-color","#eee"); 
                    $(".cutm1").attr("title","");
                     $(".qtym1").css("border-color","#eee"); 
                    $(".qtym1").attr("title","");
                  }
                   else{
                     $(".cutm1").css("border-color","#eee"); 
                     $(".cutm1").attr("title","");
                   }
                  
                }
               else{
                     $(".qtym1").css("border-color","#eee"); 
                     $(".qtym1").attr("title","");
               }
                
               
                if(qtym2==''){
                     $(".qtym2").css("border-color","red"); 
                     $(".qtym2").attr("title","error");
                  if(cutm2==''){
                     $(".cutm2").css("border-color","#eee"); 
                     $(".cutm2").attr("title","");
                     $(".qtym2").css("border-color","#eee"); 
                    $(".qtym2").attr("title","");
                  }
                   else{
                     $(".cutm2").css("border-color","#eee"); 
                     $(".cutm2").attr("title","error");
                   }
                  
                }
               else{
                     $(".qtym2").css("border-color","#eee"); 
                     $(".qtym2").attr("title","");
               }
                   
                if(qtym3==''){
                     $(".qtym3").css("border-color","red"); 
                     $(".qtym3").attr("title","error");
                  
                  if(cutm3==''){
                     $(".cutm3").css("border-color","#eee"); 
                     $(".cutm3").attr("title","");
                     $(".qtym3").css("border-color","#eee"); 
                    $(".qtym3").attr("title","");
                  }
                   else{
                      $(".cutm3").css("border-color","#eee"); 
                     $(".cutm3").attr("title","");
                   }
                  
                }
               else{
                     $(".qtym3").css("border-color","#eee"); 
                     $(".qtym3").attr("title","");
               }
               
                if(qtym4==''){
                     $(".qtym4").css("border-color","red"); 
                     $(".qtym4").attr("title","error");
                  if(cutm4==''){
                     $(".cutm4").css("border-color","#eee"); 
                     $(".cutm4").attr("title","");
                     $(".qtym4").css("border-color","#eee"); 
                    $(".qtym4").attr("title","");
                  }
                   else{
                     $(".cutm4").css("border-color","#eee"); 
                     $(".cutm4").attr("title","");
                   }
                  
                }
               else{
                     $(".qtym4").css("border-color","#eee"); 
                     $(".qtym4").attr("title","");
               }
               
                if(qtym5==''){
                    $(".qtym5").css("border-color","red"); 
                     $(".qtym5").attr("title","error");
                  
                  if(cutm5==''){
                     $(".cutm5").css("border-color","#eee"); 
                     $(".cutm5").attr("title","");
                     $(".qtym5").css("border-color","#eee"); 
                     $(".qtym5").attr("title","");
                  }
                   else{
                     $(".cutm5").css("border-color","#eee"); 
                     $(".cutm5").attr("title","");
                   }
                  
                } 
               else{
                   
                     $(".qtym5").css("border-color","#eee"); 
                     $(".qtym5").attr("title","");
               
               }
               
            $( ".qtym" ).each(function(key, val) { 
              var qtyval=$(this).val(); 
            
              if(qtyval!=''){
                  if(qtyval<10){
                     $(this).attr("title","error");
                  }
              else{
                // $(this).attr("title","error");
              }
                 }
                 var t1= $(this).attr("title");
               
               if(t1=="error"  ){ 
                    $( ".noajax" ).css('display','block');
                    $( ".addajax" ).css('display','none');
                 
                   return false; 
                 
                 
                 } 
              else{
               $( ".cutm" ).each(function(key, val) { 
                 var t3= $(this).attr("title");
                 if(t3=="error"  ){ 
                   $( ".noajax" ).css('display','block');
                    $( ".addajax" ).css('display','none');
               
                   return false; } 
                 else{
                    $( ".noajax" ).css('display','none');
                    $( ".addajax" ).css('display','block');
              }
               
                });  
              }
                
                
            }); 
                $( ".cutm" ).each(function(key, val) { 
                  var t1= $(this).attr("title");
               if(t1=="error"  ){ 
                    $( ".noajax" ).css('display','block');
                    $( ".addajax" ).css('display','none');
                 
                   return false; 
                 
                 
                 } 
              else{
               $( ".qtym" ).each(function(key, val) { 
                
                 var qtyval2=$(this).val();
                
                 if(qtyval2!=''){
                  if(qtyval2<10){
                      $(this).attr("title","error");
                  }
              else{
                
                
              }
                 }
                  var t3= $(this).attr("title");
                 if(t3=="error"  ){ 
                   $( ".noajax" ).css('display','block');
                    $( ".addajax" ).css('display','none');
               
                   return false; } 
                 else{
                    $( ".noajax" ).css('display','none');
                    $( ".addajax" ).css('display','block');
              }
                  
                
               
                }); 
              }
             
                }); 
           
               
               
               
        			                 
                    } 
             
             function cutreelprice(){
               var reelcutprice=0;
               var cutreelprice1=$(".cutm1").val();
               var cutreelprice2=$(".cutm2").val();
               var cutreelprice3=$(".cutm3").val();
               var cutreelprice4=$(".cutm4").val();
               var cutreelprice5=$(".cutm5").val();
               if(cutreelprice1==''){
               cutreelprice1=0;
               }
               if(cutreelprice2==''){
               cutreelprice2=0;
               }
               if(cutreelprice3==''){
               cutreelprice3=0;
               }
               if(cutreelprice4==''){
               cutreelprice4=0;
               }
               if(cutreelprice5==''){
               cutreelprice5=0;
               }
              
              
               var cutreelprice=parseInt(cutreelprice1)+parseInt(cutreelprice2)+parseInt(cutreelprice3)+parseInt(cutreelprice4)+parseInt(cutreelprice5);
              var reelcutprice=cutreelprice*20;
               //alert(reelcutprice);
               $(".reelcutprice").val(reelcutprice);
             }
           
           